import { BASE_API_URL } from "../layouts-upload-modal"
import cssString from "../styles/_minified/upload-zone.css"
import modalString from "../styles/_minified/modal.css"
import { CheckRes, LayoutState, PartData, UploadRes } from "../types/types"
import { hasErrors } from "../utils/checkLayoutErrors"
import { createCloseIcon, createCloudIcon, createInfoIcon, createModal, createTimeIcon } from "../utils/createElemets"
import { uploadWithProgress } from "../utils/uploadWithProgress"

// --------------------------------------------------------------------------------

customElements.define(
    "upload-zone",
    class extends HTMLElement {
        static observedAttributes = ["part-data", "index"]

        #container: HTMLDivElement
        #label: HTMLLabelElement
        #span: HTMLSpanElement

        #partData?: PartData
        #layoutIndex: number
        #uploadState: 'ready' | 'uploading' | 'check' | 'result'

        #readyElements: HTMLElement[]
        #resultElement: HTMLElement

        constructor() {
            super()

            this.#layoutIndex = 0

            this.#container = document.createElement('div')
            this.#label = document.createElement('label')
            this.#label.classList.add('ready')
            this.#span = document.createElement('span')
            this.#uploadState = 'ready'

            // Ready state elements ----------
            const readyDesktop = document.createElement('div')
            readyDesktop.classList.add('desktop')
            readyDesktop.textContent = 'Перетащите файл или'
            readyDesktop.prepend(createCloudIcon())

            const readyMobile = document.createElement('div')
            readyMobile.classList.add('mobile')
            readyMobile.textContent = 'Загрузить файл'

            const input = document.createElement('input')
            input.type = 'file'
            input.onchange = (e: Event) => {
                const inputTarget = e.target as HTMLInputElement
                const file = inputTarget.files?.item(0)

                this.#uploadFile(file)

                inputTarget.files = null
                inputTarget.value = ''
            }

            const readyDndLayer = document.createElement('div')
            readyDndLayer.classList.add('dnd-layer')
            readyDndLayer.ondragenter = e => this.#label.classList.add('hovered')
            readyDndLayer.ondragleave = e => this.#label.classList.remove('hovered')
            readyDndLayer.ondrop = (e: DragEvent) => {
                e.preventDefault()
                if (!e.dataTransfer) return

                const dataList: File[] = []

                if (e.dataTransfer.items)
                    Array.from(e.dataTransfer.items).forEach((item, i) => {
                        if (item.kind === "file") {
                            const file = item.getAsFile()
                            file && dataList.push(file)
                        }
                    })
                else
                    Array.from(e.dataTransfer.files).forEach((file, i) => {
                        dataList.push(file)
                    })

                this.#uploadFile(dataList[0])
                e.dataTransfer.clearData()
            }

            this.#readyElements = [readyDesktop, readyMobile, input, readyDndLayer]

            this.#span.textContent = 'Выберите фото с компьютера'
            this.#label.append(...this.#readyElements, this.#span)

            // Result state elements ----------
            this.#resultElement = document.createElement('div')
            this.#resultElement.classList.add('file')

        }

        async #timeOut(ms: number) {
            return new Promise((resolve, reject) => {
                setTimeout(() => resolve(true), ms)
            })
        }

        async #uploadFile(file: File | undefined | null) {
            const calcModule = document.querySelector('form.calculation-module') as HTMLFormElement | null
            const dataProduct = calcModule?.dataset.product

            if (file && window.partsData && window.selectedParams) {
                const formData = new FormData()
                formData.append('file', file)
                formData.append('id', dataProduct ?? '92') // При отрытии на странице с продуктом, нужно передавать id продукта
                formData.append('positionId', 'undefined') // Когда открываем в корзине
                formData.append('partId', this.#partData?.id ?? 'undefined')
                formData.append('partsData', JSON.stringify(window.partsData))
                formData.append('selectedParams', JSON.stringify(window.selectedParams))
                formData.append('species', 'undefined')

                this.#state = 'uploading'
                try {
                    const uploadResData = await uploadWithProgress({
                        url: BASE_API_URL + '/cart/layout/upload',
                        data: formData,
                        container: this.#label,
                        span: this.#span
                    }) as UploadRes

                    this.#state = 'check'

                    let checkResData: CheckRes | undefined = undefined
                    let attemts = 0

                    while (attemts < 100) {
                        const checkRes = await fetch(BASE_API_URL + uploadResData.checkUrl)
                        checkResData = await checkRes.json() as CheckRes

                        if (checkResData.success === -1)
                            throw new Error(checkResData.message)

                        this.#span.textContent = `${checkResData.progress}`
                        if (checkResData.success === 1) break

                        attemts++
                        if (attemts < 10)
                            await this.#timeOut(2000)
                    }


                    this.#state = 'result'

                    if (this.#partData && this.#index !== undefined) {

                        let temp = layoutsState[this.#partData.id].slice()
                        temp[this.#index] = { partData: this.#partData, uploadResData, checkResData, errors: hasErrors(checkResData), index: this.#index }
                        this.#layoutState = temp[this.#index]

                        layoutsState[this.#partData.id] = temp
                    }

                } catch (e) {
                    const err = e as Error
                    this.#state = 'ready'
                    this.#span.innerHTML = 'Выберите фото с компьютера'

                    createModal({
                        title: "Ошибка сервера",
                        subTitle: 'message' in err ? err.message : "",
                        submitText: "Ok"
                    }, this.shadowRoot)
                }
            }
        }

        set #layoutState(layoutState: LayoutState | null) {
            if (layoutState) {
                this.#resultElement.classList.add(hasErrors(layoutState.checkResData) ? 'fatal' : 'ok')
                const name = document.createElement('span')
                name.textContent = layoutState.uploadResData.original_name

                const closeBtn = document.createElement('button')
                closeBtn.append(createCloseIcon('var(--gray-500, #A0AEC0)'))
                closeBtn.onclick = () => createModal({
                    title: 'Вы уверены что хотите отменить загрузку файлов?',
                    subTitle: 'Все загруженные макеты будут утрачены',
                    submitText: 'Да, отменить',
                    cancelText: 'Не отменять',
                    action: () => {
                        if (!this.#partData) return

                        this.#state = 'ready'
                        let temp = layoutsState[this.#partData.id].slice()
                        temp[this.#index] = null
                        this.#layoutState = temp[this.#index]

                        layoutsState[this.#partData.id] = temp
                    }
                }, this.shadowRoot)

                const iconStatus = hasErrors(layoutState.checkResData) ? 'fatal' : 'ok'
                this.#resultElement.append(createInfoIcon(iconStatus), name, closeBtn)

                if (hasErrors(layoutState.checkResData)) {
                    const errorLink = document.createElement('div')
                    errorLink.classList.add('error-link')
                    errorLink.textContent = 'Смотреть замечания'
                    errorLink.onclick = () => {
                        if (!this.#partData) return
                        const layoutErrorsModal = document.createElement('layout-errors-modal')
                        layoutErrorsModal.setAttribute("part-data", this.#partData.id)
                        layoutErrorsModal.setAttribute("index", `${this.#index}`)
                        document.body.append(layoutErrorsModal)
                    }
                    this.#container.append(errorLink)
                }
            } else {
                this.#resultElement.innerHTML = ''
                this.#resultElement.setAttribute('class', 'file')
            }
        }

        get #state() {
            return this.#uploadState
        }

        set #state(state) {
            this.#uploadState = state
            this.#label.setAttribute('class', state)

            const span = document.createElement('span')
            span.classList.add('suffix')

            switch (state) {
                case 'ready':
                    this.#span.textContent = 'Выберите фото с компьютера'
                    this.#label.replaceChildren(...this.#readyElements, this.#span)
                    this.#container.replaceChildren(this.#label)
                    break

                case 'uploading':
                    this.#label.innerHTML = 'Идет загрузка макета'
                    this.#label.prepend(createTimeIcon())
                    span.textContent = 'KB'
                    this.#label.append(this.#span, span)
                    break

                case 'check':
                    this.#label.innerHTML = 'Идет проверка макета'
                    this.#label.prepend(createTimeIcon())
                    span.textContent = '%'
                    this.#label.append(this.#span, span)
                    break

                case 'result':
                    this.#container.replaceChildren(this.#resultElement)
                    break

                default:
                    break
            }
        }

        get #index() {
            return this.#layoutIndex
        }

        set #index(number) {
            this.#layoutIndex = number
            this.#container.append(this.#label)

            if (this.#partData && layoutsState[this.#partData.id][this.#index]) {
                this.#state = 'result'
                this.#layoutState = layoutsState[this.#partData.id][this.#index]
            }
        }

        connectedCallback() {
            const shadow = this.attachShadow({ mode: "open" })

            const sheet = new CSSStyleSheet()
            sheet.replaceSync(cssString + modalString)
            shadow.adoptedStyleSheets = [sheet]

            const container = document.createElement('div')
            container.classList.add('upload-zone')

            container.append(this.#container)
            shadow.append(container)
        }

        attributeChangedCallback(name: string, oldValue: string, newValue: string) {
            switch (name) {
                case 'part-data':
                    if (newValue)
                        this.#partData = partsData.find(part => part.id === newValue)
                    break

                case 'index':
                    if (newValue)
                        this.#index = +newValue
                    break

                default:
                    break
            }
        }

        disconnectedCallback() {
            this.remove()
        }
    }
)